import { ChangeAddressModel } from "@modules/shared/modals/change-personal-info/domain/entities/change-user-info.model";

export function validateEmail(email: string): boolean {
	// Regular expression for a simple email validation
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailRegex.test(email);
}

export function removeNullProps(obj: Partial<ChangeAddressModel>): ChangeAddressModel {
	const newObj: ChangeAddressModel = {
		street: "",
		city: "",
		country: "",
		zipcode: "",
		manual_address: false
	};

	for (const prop in obj) {
		if (obj[prop] !== null && obj[prop] !== undefined) {
			newObj[prop] = obj[prop];
		}
	}

	return newObj;
}
